export default "__VITE_ASSET__VtdpYTZE__"